/* Copyright (c) 2020-present CloudIO Inc */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { useLatest } from '@cloudio-saas/statex';
import { useCallback, useEffect, useRef } from 'react';

export default function useAnimationFrame(
  callback: (...args: any[]) => void,
): (...args: any[]) => void {
  const requestRef = useRef(0);
  const callbackRef = useLatest(callback);
  const argsRef = useRef<any[]>([]);

  useEffect(() => {
    return () => {
      if (requestRef.current) {
        cancelAnimationFrame(requestRef.current);
        requestRef.current = 0;
      }
    };
  }, []);

  const call = useCallback(() => {
    requestRef.current = 0;
    callbackRef.current(...argsRef.current);
  }, [callbackRef]);

  const debounce = useCallback(
    (...args: any[]) => {
      argsRef.current = args;
      if (requestRef.current) {
        return;
      }
      requestRef.current = requestAnimationFrame(call);
    },
    [call],
  );
  return debounce;
}
